/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerationCompleteDto
 */
export interface GenerationCompleteDto {
    /**
     * Firebase user ID
     * @type {string}
     * @memberof GenerationCompleteDto
     */
    userId: string;
    /**
     * Type of generation completed
     * @type {string}
     * @memberof GenerationCompleteDto
     */
    type: GenerationCompleteDtoTypeEnum;
    /**
     * ID of the generated entity
     * @type {string}
     * @memberof GenerationCompleteDto
     */
    entityId: string;
}


/**
 * @export
 */
export const GenerationCompleteDtoTypeEnum = {
    TreatmentPlan: 'treatment_plan',
    Instruction: 'instruction',
    Procedure: 'procedure'
} as const;
export type GenerationCompleteDtoTypeEnum = typeof GenerationCompleteDtoTypeEnum[keyof typeof GenerationCompleteDtoTypeEnum];


/**
 * Check if a given object implements the GenerationCompleteDto interface.
 */
export function instanceOfGenerationCompleteDto(value: object): value is GenerationCompleteDto {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    return true;
}

export function GenerationCompleteDtoFromJSON(json: any): GenerationCompleteDto {
    return GenerationCompleteDtoFromJSONTyped(json, false);
}

export function GenerationCompleteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerationCompleteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'type': json['type'],
        'entityId': json['entityId'],
    };
}

export function GenerationCompleteDtoToJSON(json: any): GenerationCompleteDto {
    return GenerationCompleteDtoToJSONTyped(json, false);
}

export function GenerationCompleteDtoToJSONTyped(value?: GenerationCompleteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'type': value['type'],
        'entityId': value['entityId'],
    };
}

